import { Injectable, signal, Signal } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  private readonly VERY_WIDE_MIN_WIDTH = '100rem';
  private readonly WIDE_MIN_WIDTH = '82rem'; // custom wide / e.g. Tailwind `@theme --breakpoint-3xl`
  private readonly DESKTOP_MIN_WIDTH = '64rem'; // tailwind lg
  private readonly TABLET_MIN_WIDTH = '48rem'; // tailwind md
  readonly isVeryWide: Signal<boolean>;
  readonly isWide: Signal<boolean>;
  readonly isDesktop: Signal<boolean>;
  readonly isTablet: Signal<boolean>;

  constructor(private breakpointObserver: BreakpointObserver) {
    const veryWideMediaQuery = `(min-width: ${this.VERY_WIDE_MIN_WIDTH})`;
    const wideMediaQuery = `(min-width: ${this.WIDE_MIN_WIDTH})`;
    const desktopMediaQuery = `(min-width: ${this.DESKTOP_MIN_WIDTH})`;
    const tabletMediaQuery = `(min-width: ${this.TABLET_MIN_WIDTH})`;

    this.isTablet = toSignal(
      this.breakpointObserver.observe(tabletMediaQuery).pipe(
        map((result) => result.matches),
        shareReplay({ refCount: true, bufferSize: 1 }),
      ),
      { initialValue: false },
    );

    this.isDesktop = toSignal(
      this.breakpointObserver.observe(desktopMediaQuery).pipe(
        map((result) => result.matches),
        shareReplay({ refCount: true, bufferSize: 1 }),
      ),
      { initialValue: false },
    );

    this.isWide = toSignal(
      this.breakpointObserver.observe(wideMediaQuery).pipe(
        map((result) => result.matches),
        shareReplay({ refCount: true, bufferSize: 1 }),
      ),
      { initialValue: false },
    );

    this.isVeryWide = toSignal(
      this.breakpointObserver.observe(veryWideMediaQuery).pipe(
        map((result) => result.matches),
        shareReplay({ refCount: true, bufferSize: 1 }),
      ),
      { initialValue: false },
    );
  }
}
